import './sections.scss';
import state from '../../state';
import SectionItem from './SectionItem';
function Sections() {
    let Sections = state.Sections.map ((section, idx) =>
    {    
        return ( 
        <div  key={idx} className="cart" id={section[0].id}>
            <div className="cart-title-bg">
                <div className="wrapper">
                    <div className="main__wrapper">
                        <h1>{section[0].h1}</h1>
                    </div>
                </div>
            </div>
            <div className="wrapper">
                <div className="main__wrapper">
                    <SectionItem  sectionInfo={section} />
                </div>
            </div>
        </div>
    )});
return (
    <div className='sectionList'>{Sections}</div>
)}
export default Sections;